import { SimpleDialogData } from './dialog.definitions';

export const MultiFactorAuthDeleteDialogSimpleData: SimpleDialogData = new SimpleDialogData({
    Title: $localize`:@@CommonDeactivateMFADialogTitle:Disable 2-Factor Authentication (2FA)`,
    Text: $localize`:@@CommonDeactivateMFADialogText:Are you sure you want to disable 2-Factor Authentication? You will still need to use your email address and password to log in.`,
    PrimaryButtonText: $localize`:@@CommonDeactivateMFAButttonText:Disable 2FA`
});
